<template>
    <!-- <button>dfd</button> -->
    <!-- <span class="icon-chip"> -->
      <vs-chip class="ag-grid-cell-chip"  color="primary" >
      <feather-icon
        icon="EyeIcon"
        svgClasses="h-5 w-5 text-white cursor-pointer"
        @click="confirmDeleteRecord"
      />
      </vs-chip>
    <!-- </span> -->

</template>

<script>
import {ref} from 'vue';
export default {
  name: "CellRendererActions",
  setup() {
    const modalActive = ref(false);
    return {modalActive}
  },
  methods: {
    editRecord() {
      this.$router
        .push(`/engineer/engineer-edit/${this.params.data.id}`)
        .catch(() => {});

      /*
              Below line will be for actual product
              Currently it's commented due to demo purpose - Above url is for demo purpose

              this.$router.push("/apps/user/user-edit/" + this.params.data.id).catch(() => {})
            */
    },
    confirmApproveRecord() {
      this.$store
        .dispatch("userManagement/approveRecord", this.params.data.id)
        .then((res) => {
          this.$router.push({name : 'Refresh Router'});
        });
    },
    confirmRejectRecord() {
      this.$store
        .dispatch("userManagement/rejectRecord", this.params.data.id)
        .then((res) => {
          this.$router.push({name : 'Refresh Router'});
          // this.$router.push('/engineer/list');
        });
    },
    confirmDeleteRecord() {
      this.params.data.temp(this.params.data)
      // this.$vs.dialog({
      //   type: "alert",
      //   color: "danger",
      //   title: "Confirm Delete",
      //   text: `You are about to delete "${this.params.value}"`,
      //   accept: this.deleteRecord,
      //   acceptText: "Delete",
      // });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      // this.showDeleteSuccess()

      /* UnComment below lines for enabling true flow if deleting user */
      this.$store
        .dispatch("userManagement/removeRecord", this.params.data.id)
        .then(() => {
          this.showDeleteSuccess();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    toggleModal(){
      alert('sdfd');
      this.modalActive = true;
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "User Deleted",
        text: "The selected user was successfully deleted",
      });
    },
  },
};
</script>
<style>
.icon-chip {
  /* background-color: dodgerblue; */

}
</style>